import { v4 as uuidv4 } from 'uuid';
import { useEffect, useReducer } from "react";
import { DefaultGrid } from '../../../../components/grids/default/defaultGrid';
import useGridFilter from '../../../../system/hooks/useGridFilter';
import { useAppContext } from '../../../../system/providers/appContextProvider';
import { usePluginContext } from '../../../../system/providers/plugin';
import { initialState, reducer } from './ReducerEx';
import { LabelPrintScenarioItemsPluginSettings } from './LabelPrintScenarioItemsPluginSettings';
import { LabelPrintScenarioDataProvider } from '../../../../Services/DataProviders/LabelPrintScenarioDataProvider';

export const LabelPrintScenarioItemsPluginView = () => {
    const appCtx = useAppContext();
    const pluginCtx = usePluginContext();
    const dataProvider = new LabelPrintScenarioDataProvider(appCtx.coreApiService);

    const [gridFilter, dispatchGridFilter] = useGridFilter();
    const [state, dispatch] = useReducer(reducer, initialState)

    useEffect(() => {
        if (pluginCtx.masterGrid.selectedItem) {
            const idGlobal: string = pluginCtx.masterGrid.selectedItem.idGlobal
            dataProvider.getItemsView(idGlobal, gridFilter, (entities, totalCount) => {
                dispatch({ type: 'setItems', payload: entities })
            })
        }
    }, [pluginCtx.masterGrid.selectedItem?.idGlobal, gridFilter])


    return <DefaultGrid
        gridId={uuidv4()}
        data={state.items}
        totalCount={state.items.length}
        filter={gridFilter}
        plugin={LabelPrintScenarioItemsPluginSettings}
        selectedItem={undefined}
        onSelect={(row) => { }}
        onSort={(i) => dispatchGridFilter({ type: "sort", payload: i.propertyName })}
        onFilterDelete={(i) => dispatchGridFilter({ type: "deleteColumnFilter", payload: i.propertyName })}
        onPageNumberChange={(n) => dispatchGridFilter({ type: "changePageNumber", payload: { pageNumber: n } })}
        onNumberPerPageChange={(n) => dispatchGridFilter({ type: "changeNumberPerPage", payload: { numberPerPage: n } })}
    />
}